export enum Resources {
   CTAddNewRow = 'chaos-table.new-row',
   CTJoinItems = 'chaos-table.join-items',
   CTCloseRow = 'chaos-table.close-row',
   CTSendReminder = 'chaos-table.send-reminder',
   CTSendEnrollment = 'chaos-table.send-enrollment',
   CTEducationStartEdit = 'chaos-table.ed-start-edit',
   CTProjectEdit = 'chaos-table.project-edit',
   CTAreaEdit = 'chaos-table.area-edit',
   CTCommentEdit = 'chaos-table.comment-edit',
   CTCheckEdit = 'chaos-table.check-edit',
   CTLanguageEdit = 'chaos-table.language-edit',
   CTMenu = 'chaos-table.menu',
   CTHistoryMenu = 'chaos-table.history-menu',
   DictionaryMenu = 'dictionary.menu',
   DictEdit = 'dictionary.edit',
   DictDelete = 'dictionary.delete'
}
